import { createFrontendRouter } from '@metorial/microfrontend';
import { Outlet } from 'react-router-dom';
import { productSlice } from './product';
import { accountSlice } from './slices/account';
import { authSlice } from './slices/auth';
import { indexSlice } from './slices/index';
import { joinSlice } from './slices/join';
import { organizationSlice } from './slices/organization';

// Upstream moved the auth, account and organization pages to its enterprise
// shell (7ee2d396a); the OSS build needs them to be usable on its own, so they
// are restored under ./slices. There is no onboarding: signing in puts everyone
// in the one organization (homeOrganizationService in the core API).
export let App = createFrontendRouter({
  frontends: [
    indexSlice(''),
    authSlice('auth'),
    accountSlice('account'),
    organizationSlice('o'),
    joinSlice('join'),
    productSlice('i')
  ],
  layout: <Outlet />
});
